import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from 'recharts';
import gaugeDialUtils from './gaugeDialUtils';

function GaugeDial({ configuration, thresholds, value }) {
    const dialUtilities = gaugeDialUtils(configuration, value, thresholds);
    dialUtilities.initialize();

    const thresholdCells = dialUtilities.getThresholdCells();
    const valueCells = dialUtilities.getValueCells();

    function renderCustomizedLabel(viewBox) {
        const magicFontRatio = 5 / 16;
        const fontSize = `${
            Math.floor(viewBox.innerRadius) * magicFontRatio
        }px`;

        return (
            <g>
                <text
                    x={viewBox.cx}
                    y={
                        viewBox.cy -
                        viewBox.innerRadius *
                            (dialUtilities.labelAboveCenterPercentage / 100)
                    }
                    style={{ fontSize }}
                    textAnchor="middle"
                    dominantBaseline="middle"
                >
                    {dialUtilities.getValueLabel()}
                </text>
            </g>
        );
    }

    return (
        <ResponsiveContainer>
            <PieChart>
                <Pie
                    startAngle={dialUtilities.startAngle}
                    endAngle={dialUtilities.endAngle}
                    data={thresholdCells}
                    dataKey="value"
                    innerRadius="82%"
                    outerRadius="88%"
                    isAnimationActive={false}
                >
                    {thresholdCells.map((entry, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Cell key={`threshold-${index}`} {...entry} />
                    ))}
                </Pie>
                <Pie
                    startAngle={dialUtilities.startAngle}
                    endAngle={dialUtilities.endAngle}
                    data={valueCells}
                    dataKey="value"
                    innerRadius="65%"
                    outerRadius="80%"
                    isAnimationActive={false}
                >
                    {valueCells.map((entry, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Cell key={`cell-${index}`} {...entry} />
                    ))}
                    <Label
                        content={({ viewBox }) =>
                            renderCustomizedLabel(viewBox)
                        }
                    />
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
}

GaugeDial.propTypes = {
    configuration: PropTypes.instanceOf(Object).isRequired,
    thresholds: PropTypes.instanceOf(Object).isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default React.memo(
    GaugeDial,
    (prevProps, nextProps) =>
        _.isEqual(prevProps.value, nextProps.value) &&
        _.isEqual(prevProps.thresholds, nextProps.thresholds)
);
